import { render, staticRenderFns } from "./Swichuser.vue?vue&type=template&id=501fe099&scoped=true&"
import script from "./Swichuser.vue?vue&type=script&lang=js&"
export * from "./Swichuser.vue?vue&type=script&lang=js&"
import style0 from "./Swichuser.vue?vue&type=style&index=0&id=501fe099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fe099",
  null
  
)

component.options.__file = "Swichuser.vue"
export default component.exports